/**
 * Accept only numeric 3234.21212, -23.323232
 */

angular.module('qkr').directive('numeric', ['$filter', '$locale', function($filter, $locale) {
    return {
        require: '?ngModel',
        link(scope, element, attrs, ngModelCtrl) {
            if (!ngModelCtrl) {
                return;
            }

            ngModelCtrl.$parsers.push((val) => {
                if (!val) {
                    return;
                }
                const clean = val.replace(/[^-?\d*\.,]+/g, '');
                const display = $filter('number')(clean);

                if (val !== clean) {
                    ngModelCtrl.$setViewValue(display);
                    ngModelCtrl.$render();
                }

                return accounting.unformat(clean, $locale.NUMBER_FORMATS.DECIMAL_SEP);
            });
            
            ngModelCtrl.$formatters.unshift((val) => {
                const display = $filter('number')(val);

                return display;
            });

            element.bind('keypress', (event) => {
                if (event.keyCode === 32) {
                    event.preventDefault();
                }
            });
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/directives/numeric.js